// extracted by mini-css-extract-plugin
export default {"autoComplete":"ST-z","error":"TT-z","disabled":"UT-z"};